
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { useStore } from "../zustand/store";
import Sidebar from "../components/Sidebar";
import svg from "../components/svg";
import { AlertMsg, assetsUrlPath } from "../components/commonAction";


const Dashboard = ({ pageTitle }) => {
    let store = useStore(state => state);
    let { role, token, isVerified } = store.userData;
    let appList = store.appList;
    const isAdmin = role === 'admin';
    let canApplyAsAffiliate = role === 'user';

    const activeApps   = Object.entries(appList).filter(([, v]) => v.status === 1);
    const upcomingApps = Object.entries(appList).filter(([, v]) => v.status === 0);

    return (
        <>
            <Helmet><title>{pageTitle}</title></Helmet>
            <div className="pxl_mainWrapper">
                <Sidebar />
                <div className="pxl-admin-dashboard-wrapper">
                    <div className="pxl_rightBar_assets">

                        {/* ── Header ── */}
                        <div className="pxl-rb-header-wrap">
                            <div className="pxl-headingTop">
                                <h2 className="pxl-rb-header-heading">{pageTitle.split(' · ')[0]}</h2>
                            </div>
                            <div className="pxl-rb-header-right">
                                <div className="pxl-header-toogle-btn" onClick={() => store.updateStore("resMenuToggle", !store.resMenuToggle)}>
                                    <svg className="pxl-header-toogle-svg" viewBox="0 0 100 100" width="80">
                                        <path className="pxl-header-toogle-svg-line pxl-header-toogle-svg-line-top" d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20" />
                                        <path className="pxl-header-toogle-svg-line pxl-header-toogle-svg-line-middle" d="m 30,50 h 40" />
                                        <path className="pxl-header-toogle-svg-line pxl-header-toogle-svg-line-bottom" d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className="pxl-dash-body">

                            {/* ── Hero banner ── */}
                            <div className="pxl-dash-hero">
                                <div className="pxl-dash-hero-main" style={{ backgroundImage: 'url(/assets/images/profileBanner.png)' }}>
                                    <div className="pxl-dash-hero-text">
                                        <p className="pxl-dash-hero-eyebrow">Featured App</p>
                                        <h2>{appList.showcaseai?.toolTip}</h2>
                                        <p className="pxl-dash-hero-sub">Create lifelike avatars, showcase your products, and make your brand speak — effortlessly with ShowcaseAI.</p>
                                        <button
                                            className="pxl-dash-hero-btn"
                                            onClick={() => { if (!isAdmin) window.open(appList.showcaseai?.url + token, '_blank'); }}
                                            disabled={isAdmin}
                                            title={isAdmin ? 'Admin accounts cannot launch applications' : undefined}
                                        >
                                            Explore Now
                                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M5 12h14M12 5l7 7-7 7"/>
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="pxl-dash-hero-img">
                                        <img src="/assets/images/dashboard/img1.png" alt="" />
                                    </div>
                                </div>

                                {!isAdmin && <div className="pxl-dash-upgrade-card" style={{ backgroundImage: 'url(/assets/images/updatesBg.png)' }}>
                                    <div className="pxl-dash-upgrade-inner">
                                        <div className="pxl-dash-upgrade-icon">
                                            <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                                            </svg>
                                        </div>
                                        <h3>Upgrade to Premium</h3>
                                        <p>Unlock exclusive benefits with premium membership</p>
                                        <Link to="/pricing" className="pxl-dash-upgrade-btn">Upgrade Now</Link>
                                    </div>
                                </div>}
                            </div>

                            {/* ── Affiliate CTA ── */}
                            {canApplyAsAffiliate && (
                                <div className="pxl-dash-affiliate">
                                    {/* decorative background */}
                                    <svg className="pxl-aff-deco-svg" viewBox="0 0 1200 96" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
                                        {/* dot grid */}
                                        {Array.from({length: 18}).map((_, col) =>
                                            Array.from({length: 5}).map((_, row) => (
                                                <circle
                                                    key={`${col}-${row}`}
                                                    cx={col * 68 + 34}
                                                    cy={row * 22 + 5}
                                                    r="1.5"
                                                    fill="rgba(255,255,255,0.18)"
                                                />
                                            ))
                                        )}
                                        {/* large rings — right side */}
                                        <circle cx="1160" cy="48" r="80"  fill="none" stroke="rgba(255,255,255,0.10)" strokeWidth="1"/>
                                        <circle cx="1160" cy="48" r="55"  fill="none" stroke="rgba(255,255,255,0.10)" strokeWidth="1"/>
                                        <circle cx="1160" cy="48" r="30"  fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.12)" strokeWidth="1"/>
                                        {/* medium ring — left */}
                                        <circle cx="80"  cy="48" r="60"  fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="1"/>
                                        <circle cx="80"  cy="48" r="36"  fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.10)" strokeWidth="1"/>
                                        {/* diagonal accent line */}
                                        <line x1="300" y1="0" x2="500" y2="96" stroke="rgba(255,255,255,0.07)" strokeWidth="1"/>
                                        <line x1="360" y1="0" x2="560" y2="96" stroke="rgba(255,255,255,0.05)" strokeWidth="1"/>
                                        {/* percent symbol — faint watermark */}
                                        <text x="950" y="80" fontSize="88" fontWeight="900" fontFamily="sans-serif" fill="rgba(255,255,255,0.05)">%</text>
                                    </svg>

                                    <div className="pxl-dash-affiliate-icon">
                                        <svg width="22" height="22" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 2C7 1.44772 7.44772 1 8 1H12C12.5523 1 13 1.44772 13 2V4H7V2Z" fill="#6F10B9"/>
                                            <path fillRule="evenodd" clipRule="evenodd" d="M0 6C0 4.89543 0.895431 4 2 4H18C19.1046 4 20 4.89543 20 6V15C20 16.1046 19.1046 17 18 17H2C0.895431 17 0 16.1046 0 15V6ZM9 10H11V8H9V10ZM9 10H0V12H9V10ZM11 10H20V12H11V10Z" fill="#6F10B9"/>
                                        </svg>
                                    </div>
                                    <div className="pxl-dash-affiliate-text">
                                        <h3>Earn commission with PixaLab</h3>
                                        <p>Promote PixaLab to your audience and earn a share of every purchase you refer.</p>
                                    </div>
                                    <Link to="/affiliate/signup" className="pxl-dash-affiliate-btn">
                                        Become an affiliate
                                        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M5 12h14M12 5l7 7-7 7"/>
                                        </svg>
                                    </Link>
                                </div>
                            )}

                            {/* ── Apps ── */}
                            {activeApps.length > 0 && (
                                <div className="pxl-dash-section">
                                    <div className="pxl-dash-section-header">
                                        <h2>Apps</h2>
                                        <span className="pxl-dash-section-count">{activeApps.length}</span>
                                    </div>
                                    <div className="pxl-dash-apps-grid">
                                        {activeApps.map(([key, val]) => (
                                            <div
                                                key={key}
                                                className={`pxl-dash-app-card pxl-dashboard-app-color-box-${val.icon}${isAdmin ? ' pxl-dash-app-card--disabled' : ''}`}
                                                title={isAdmin ? 'Admin accounts cannot launch applications' : undefined}
                                                onClick={() => {
                                                    if (isAdmin) return;
                                                    if (isVerified) {
                                                        window.open(val?.launchUrl ? val.launchUrl : val.url + token, '_blank');
                                                    } else {
                                                        AlertMsg('error', 'Error', 'Please verify your account first.');
                                                    }
                                                }}
                                            >
                                                <div className="pxl-dash-app-card-top">
                                                    <div className="pxl-dashboard-app-img">
                                                        {val.logoUrl
                                                            ? <img src={assetsUrlPath(val.logoUrl)} alt={val.title} style={{ maxWidth: 30, maxHeight: 30, width: 'auto', height: 'auto', objectFit: 'contain' }} />
                                                            : svg.app[val.icon]}
                                                    </div>
                                                </div>
                                                <div className="pxl-dash-app-card-body">
                                                    <h3>{val.title}</h3>
                                                    <p>{val.toolTip}</p>
                                                </div>
                                                <div className="pxl-dash-app-card-footer">
                                                    <span className={`pxl-dash-explore-btn pxl-dashboard-box-right`}>
                                                        Explore Now
                                                        <span className="pxl-dashboard-box-right-icon">{svg.app.dashboardAppSchedularSvg}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* ── Upcoming ── */}
                            {upcomingApps.length > 0 && (
                                <div className="pxl-dash-section">
                                    <div className="pxl-dash-section-header">
                                        <h2>Upcoming</h2>
                                        <span className="pxl-dash-section-count">{upcomingApps.length}</span>
                                    </div>
                                    <div className="pxl-dash-apps-grid">
                                        {upcomingApps.map(([key, val]) => (
                                            <div key={key} className={`pxl-dash-app-card pxl-dash-app-card--upcoming pxl-dashboard-app-color-box-${val.icon}`}>
                                                <div className="pxl-dash-app-card-top">
                                                    <div className="pxl-dashboard-app-img">
                                                        {val.logoUrl
                                                            ? <img src={assetsUrlPath(val.logoUrl)} alt={val.title} style={{ maxWidth: 30, maxHeight: 30, width: 'auto', height: 'auto', objectFit: 'contain' }} />
                                                            : svg.app[val.icon]}
                                                    </div>
                                                    <span className="pxl-dash-coming-pill">Coming soon</span>
                                                </div>
                                                <div className="pxl-dash-app-card-body">
                                                    <h3>{val.title}</h3>
                                                    <p>{val.toolTip}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Dashboard;
